import { FC, useState } from 'react';
import { useDispatch } from 'react-redux';
import includes from 'lodash/includes';
import Button from 'antd/lib/button/button';
import Input from 'antd/lib/input/Input';
import Upload from 'antd/lib/upload/Upload';

import { updateSettingsByKeyAction } from 'store/actions/settingsActions';
import { ESettingsKey } from 'store/reducers/settingsReducer/settingsTypes';
import getImageCdnUrl from 'utils/getImageCdnUrl';
import sendNotification, { ENotificationTypes } from 'utils/sendNotification';
import { ErrorIcn, UploadIcn } from 'utils/icons';

import MessageWrapper from '../MessageWrapper/MessageWrapper';

const acceptedImagesTypes = ['image/png', 'image/jpg', 'image/jpeg', 'image/webp', 'image/avif'];
const urlPattern = new RegExp('^https?:\\/\\/.*\\.(?:png|jpg|jpeg|webp|avif)(\\?.*)?$');

interface AddImageProps {
  onModalClose: () => void;
}

const AddImage: FC<AddImageProps> = ({ onModalClose }) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isUploading, setIsUploading] = useState<boolean>(false);
  const [logoUrl, setLogoUrl] = useState<string>('');
  const isValidLogoUrl = urlPattern.test(logoUrl);

  const handleSubmit = async() => {
    setIsLoading(true);
    await dispatch(updateSettingsByKeyAction({ logoUrl }, ESettingsKey.StoreSettings));
    onModalClose();
  };

  const handleUploadFile = async({ file }: any) => {
    if (includes(acceptedImagesTypes, file.type)) {
      setIsUploading(true);
      const url = await getImageCdnUrl(file);

      await dispatch(updateSettingsByKeyAction({ logoUrl: url }, ESettingsKey.StoreSettings));
      onModalClose();
    } else {
      sendNotification(ENotificationTypes.Error, 'Incorrect file type');
    }
  };

  return (
    <div className="w-96">
      <h2 className="my-4">Add Image</h2>
      <MessageWrapper isVisible={!!(!isValidLogoUrl && logoUrl)} className="my-1.5 text-red-50 bg-red-10">
        <ErrorIcn className="min-w-[24px]"/> Invalid Image Url
      </MessageWrapper>
      <div className="mb-1">Image Url</div>
      <div className="flex items-center">
        <Input
          autoFocus
          size="large"
          value={logoUrl}
          placeholder="Enter Image Url"
          onChange={({ target: { value } }) => setLogoUrl(value)}
        />
        <Button
          size="large"
          type="primary"
          loading={isLoading}
          className="ml-2.5"
          disabled={!isValidLogoUrl}
          onClick={handleSubmit}
        >
          Add Image
        </Button>
      </div>
      <Upload
        accept=".png,.jpg,.jpeg,.webp,.avif"
        showUploadList={false}
        customRequest={handleUploadFile}
      >
        <Button
          type="link"
          className="inline-flex items-center text-black-70 mt-2.5 p-0 gap-x-2.5 dark:text-black-30"
          icon={<UploadIcn />}
          loading={isUploading}
        >
          Upload Image
        </Button>
      </Upload>
    </div>
  );
};

export default AddImage;
